import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {CfiCompanyType} from "../types/CfiCompanyType";

export const useGetCfiCompanies = (companyId: number | undefined) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {data, isLoading} = useQuery({
        queryKey: ['get-cfi-companies', companyId],
        queryFn: async () => await apiClient.get('cfi-routing/cfis') as CfiCompanyType[]
    });

    return {
        data,
        isLoading
    };
};
